export const CANADA_BASE_URL = process.env.NEXT_PUBLIC_CANADA_BASE_URL;
export const BIG_COMMERCE_ORDER_LINK = `${CANADA_BASE_URL}/account.php?action=order_status`;
export const BIG_COMMERCE_WISHLIST_LINK = `${CANADA_BASE_URL}/wishlist.php`;
